"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStocks = updateStocks;
async function updateStocks(machineRepo, machineId, reFills) {
    return await machineRepo.updateStocks(machineId, reFills);
}
